/** BC sends 0001-01-01 for an empty date */
export const isBlankDate = (value?: string | null) => !value || value.startsWith('0001-');

export const formatDate = (value?: string | null) =>
  isBlankDate(value) ? '–' : new Date(value as string).toLocaleDateString('sv-SE');

export const formatLongDate = (value?: string | null) =>
  isBlankDate(value)
    ? '–'
    : new Date(value as string).toLocaleDateString('sv-SE', { day: 'numeric', month: 'long', year: 'numeric' });

export const formatCurrency = (amount?: number | null, decimals = 2) =>
  (amount || 0).toLocaleString('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

/** A deduction shown as a negative amount ("−1 250,00 kr"); zero stays "0,00 kr" without a minus */
export const formatDeduction = (amount?: number | null, decimals = 2) =>
  Math.abs(amount || 0) < 0.005 ? formatCurrency(0, decimals) : `−${formatCurrency(Math.abs(amount as number), decimals)}`;

/** "1 sep – 30 sep 2026" */
export const formatPeriod = (start?: string | null, end?: string | null) => {
  if (isBlankDate(start) || isBlankDate(end)) return '–';
  const from = new Date(start as string);
  const to = new Date(end as string);
  const sameYear = from.getFullYear() === to.getFullYear();
  const fromText = from.toLocaleDateString('sv-SE', { day: 'numeric', month: 'short', ...(sameYear ? {} : { year: 'numeric' }) });
  const toText = to.toLocaleDateString('sv-SE', { day: 'numeric', month: 'short', year: 'numeric' });
  return `${fromText} – ${toText}`;
};
